module.exports = __webpack_public_path__ + "logo.png?41bea3bd3d0c663fcd9b0d41ce09caa5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 173
// module chunks = 0